/*
    Add here your own custom javascript
*/
document.querySelector('.show-more-product').addEventListener('click', function() {
    this.parentNode.style.maxHeight = 'unset';
    this.remove();
});